// @flow
import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';

export const cmsActions = {
  UPDATE_PAGE_NUMBER: 'UPDATE_PAGE_NUMBER',
  GET_EMAILS: 'GET_EMAILS',
  DRAFT_EMAILS: 'DRAFT_EMAILS',
  ADD_ATTACHMENT: ' ADD_ATTACHMENT',
  DELETE_ATTACHMENT: 'DELETE_ATTACHMENT',
  GET_DETAILED_EMAIL: 'GET_DETAILED_EMAIL',
  DOWNLOAD_CSV: 'DOWNLOAD_CSV',
  SET_IS_LOADING_DATA: 'SET_IS_LOADING_DATA',
  GET_ALL_MAILS: 'GET_ALL_MAILS',
  UPDATE_FILTER_FIELDS: 'UPDATE_FILTER_FIELDS',
  SET_EMAIL_DATA: 'SET_EMAIL_DATA',
  RESET_EMAIL_DATA: 'RESET_EMAIL_DATA',
  SET_DRAFT_RESPONSE: 'SET_DRAFT_RESPONSE',
  SET_MODAL_LOADER: 'SET_MODAL_LOADER'
};

export const getFilterFieldUpdateAction = payload => ({
  type: cmsActions.UPDATE_FILTER_FIELDS,
  payload
});

export const setModalLoader = payload => dispatch => {
  dispatch({ type: cmsActions.SET_MODAL_LOADER, payload });
};

export const resetEmailData = payload => dispatch => {
  dispatch({ type: cmsActions.RESET_EMAIL_DATA, payload });
};

export const updateFilterFields = (fieldType, fieldVal) => dispatch => {
  dispatch(getFilterFieldUpdateAction({ [fieldType]: fieldVal }));
};

export const setDraftResponse = payload => dispatch => {
  dispatch({ type: cmsActions.SET_DRAFT_RESPONSE, payload });
};
export const setEmailDataAction = payload => ({
  type: cmsActions.SET_EMAIL_DATA,
  payload
});

export const updateEmailDataObj = (fieldType, fieldVal) => dispatch => {
  dispatch(setEmailDataAction({ [fieldType]: fieldVal }));
};

export const getAllMailsDataAction = payload => ({
  type: cmsActions.GET_ALL_MAILS,
  payload
});

export const updatePageNumber = payload => dispatch => {
  dispatch({
    type: cmsActions.UPDATE_PAGE_NUMBER,
    payload: payload
  });
};

export const getAllMails = () => (dispatch, getState) => {
  dispatch(
    getAllMailsDataAction({
      isLoading: true
    })
  );
  dispatch({
    type: cmsActions.SET_IS_LOADING_DATA,
    payload: true
  });

  let apiEndPoint = 'getEmailSummary';

  const { cmsData } = getState();
  const { pageNumber, pageSize, filters } = cmsData;

  let startDate = filters.startDate;
  let endDate = filters.endDate;

  let replaceParamsArr = [
    { key: 'pageNumber', val: pageNumber + 1 },
    { key: 'pageSize', val: pageSize },
    { key: 'startDate', val: startDate },
    { key: 'endDate', val: endDate }
  ];
  if (filters.requestStatus && filters.requestStatus !== 'ALL') {
    replaceParamsArr.push({ key: 'status', val: filters.requestStatus });
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: apiEndPoint,
    method: 'GET',
    replaceParamsArr: replaceParamsArr,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getAllMailsDataAction({
            isLoading: false,
            allMailsData: {
              mailsList: res.payload,
              totalRecords: res.totalElements
            }
          })
        );
      } else {
        toastr.error(
          'Something went wrong!',
          res.errorMessage || 'Could not fetch emails..'
        );
      }
      dispatch({
        type: cmsActions.SET_IS_LOADING_DATA,
        payload: false
      });
    },
    failureCb: res => {
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not fetch emails..'
      );
      dispatch({
        type: cmsActions.SET_IS_LOADING_DATA,
        payload: false
      });
    },
    catchCb: res => {
      toastr.error('Something went wrong!', 'Could not fetch emails..');
      dispatch({
        type: cmsActions.SET_IS_LOADING_DATA,
        payload: false
      });
    }
  };

  return makeApiCall(requestObj);
};

export const getEmails = () => dispatch => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getEmails',
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch({
          type: cmsActions.GET_EMAILS,
          payload: {
            isLoadingData: false,
            emails: res.payload,
            emailsCount: {
              ZOOM_RETAIL:
                res.payload && res.payload['ZOOM_RETAIL']
                  ? res.payload['ZOOM_RETAIL'].length
                  : 0,
              ZOOM_FRANCHISE:
                res.payload && res.payload['ZOOM_FRANCHISE']
                  ? res.payload['ZOOM_FRANCHISE'].length
                  : 0,
              ZOOM_CORPORATE:
                res.payload && res.payload['ZOOM_CORPORATE']
                  ? res.payload['ZOOM_CORPORATE'].length
                  : 0
            }
          }
        });
      } else {
        dispatch({
          type: cmsActions.GET_EMAILS
        });
        toastr.error('Error', 'Failed to get Emails');
      }
    },
    failureCb: err => {
      dispatch({
        type: cmsActions.GET_EMAILS,
        payload: {
          isLoadingData: false
        }
      });
    },
    catchCb: err => {
      dispatch({
        type: cmsActions.GET_EMAILS,
        payload: {
          isLoadingData: false
        }
      });
    }
  };
  return makeApiCall(requestObj);
};

export const getDetailedEmail = (id, cb = null) => dispatch => {
  dispatch({
    type: cmsActions.GET_DETAILED_EMAIL,
    payload: { isLoading: true }
  });

  dispatch(setModalLoader(true));

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getDetailedEmail',
    pathVariables: [{ key: '{communicationId}', val: id }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch({
          type: cmsActions.GET_DETAILED_EMAIL,
          payload: res.payload
        });

        dispatch({
          type: cmsActions.SET_DRAFT_RESPONSE,
          payload: {
            attachmentsDTO: res.payload.attachmentDTOList || [],
            subject: res.payload.subject || '',
            to: res.payload.toEmail || [],
            cc: res.payload.ccEmail || [],
            // bcc: res.payload.bccEmail || [], // might need to send it later
            content: res.payload.body || '',
            clientGroup: res.payload.serviceTypeList || [],
            id: res.payload.id || id || null
          }
        });

        dispatch({
          type: cmsActions.SET_IS_LOADING_DATA,
          payload: false
        });
        if (cb) {
          cb(res.payload);
        }
      } else {
        toastr.error('Error', `Failed to fetch ${expenseType} List`);
      }
      dispatch(setModalLoader(false));
    },
    failureCb: err => {
      dispatch({
        type: cmsActions.GET_DETAILED_EMAIL,
        payload: { isLoading: false }
      });
      dispatch(setModalLoader(false));
    },
    catchCb: err => {
      dispatch({
        type: cmsActions.GET_DETAILED_EMAIL,
        payload: { isLoading: false }
      });
      dispatch(setModalLoader(false));
    }
  };

  return makeApiCall(requestObj);
};

export const saveAsDraftOrSendEmail = (
  draftEmailData,
  cb = null,
  saveAsDraft = true
) => dispatch => {
  dispatch(setModalLoader(true));
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: saveAsDraft ? 'saveDraftEmail' : 'sendEmail',
    method: 'POST',
    data: draftEmailData,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        if (cb) {
          cb();
          dispatch(getAllMails());
        }

        dispatch(updateEmailDataObj('id', res.payload));

        dispatch({
          type: cmsActions.SET_IS_LOADING_DATA,
          payload: false
        });
      } else {
        dispatch({
          type: cmsActions.DRAFT_EMAILS
        });
        toastr.error('Error', 'Failed');
      }
      dispatch(setModalLoader(false));
    },
    failureCb: err => {
      dispatch(setNewCommunication(true));
      dispatch(setModalLoader(false));
    },
    catchCb: err => {
      dispatch({
        type: cmsActions.DRAFT_EMAILS,
        payload: {
          isLoadingData: false
        }
      });
      dispatch(setModalLoader(false));
    }
  };
  return makeApiCall(requestObj);
};

export const saveDraftEmail = (draftEmailData, cb = null) => dispatch => {
  console.log(cb, '=== cb');
  dispatch(saveAsDraftOrSendEmail(draftEmailData, cb, true));
};

const returnEmails = (cg, emails) => {
  return (cg || []).reduce((acc, tab) => {
    if (emails && emails[tab]) {
      // Optional chaining to avoid errors
      acc = acc.concat(emails[tab]);
    }
    return acc;
  }, []);
};

export const sendEmail = (draftEmailData, cb = null) => (
  dispatch,
  getState
) => {
  if (!draftEmailData) {
    toastr.error('Validation failed', 'Please fill the details');
    return;
  }
  if (draftEmailData && !draftEmailData.body) {
    toastr.error(
      'Please fill the details',
      'Content is mandatory to send email.'
    );
    return;
  }

  const { cmsData } = getState();
  const { emailData, emails } = cmsData;
  // draftEmailData.bccEmail = returnEmails(emailData.clientGroup, emails);

  const contentTemplate = `
  <div
    style={{
    width: '100%',
    marginBottom: '5px',
    marginTop: '10px'
   }}
  >
   Dear Client,
   </div>
  ${draftEmailData.body}
   <div
   style={{
    width: '100%',
    marginBottom: '5px',
    marginTop: '10px'
   }}
   >
   Regards,
   </div>
   <div style={{ width: '100%', marginBottom: '25px' }}>
    MESPL Team
   </div>
  `;
  draftEmailData.body = contentTemplate;
  dispatch(saveAsDraftOrSendEmail(draftEmailData, cb, false));
};

export const addAttachment = obj => (dispatch, getState) => {
  const { cmsData } = getState();
  const { emailData } = cmsData;
  dispatch({
    type: cmsActions.SET_IS_LOADING_DATA,
    payload: true
  });

  dispatch({
    type: cmsActions.ADD_ATTACHMENT,
    payload: { isLoading: true }
  });
  let params = {};
  if (obj && obj.id) {
    params = { communicationId: obj.id };
  }
  const formData = new FormData();
  formData.append('file', obj.file);

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'addAttachment',
    method: 'POST',
    postFormData: true,
    data: formData,
    ...(params && Object.keys(params).length > 0 ? { params: params } : {}),
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch({
          type: cmsActions.ADD_ATTACHMENT,
          payload: {
            newCommunication: true
          }
        });

        let updateAttachments = null;
        if (emailData.attachmentsDTO) {
          updateAttachments = [...emailData.attachmentsDTO, res.payload];
        } else {
          updateAttachments = [res.payload];
        }
        dispatch(updateEmailDataObj('attachmentsDTO', updateAttachments));
        dispatch({
          type: cmsActions.SET_IS_LOADING_DATA,
          payload: true
        });
      } else {
        dispatch({
          type: cmsActions.ADD_ATTACHMENT
        });
        toastr.error('Error', 'Failed to get Emails');
      }
    },
    failureCb: err => {
      dispatch({
        type: cmsActions.ADD_ATTACHMENT,
        payload: {
          isLoadingData: false
        }
      });
    },
    catchCb: err => {
      dispatch({
        type: cmsActions.ADD_ATTACHMENT,
        payload: {
          isLoadingData: false
        }
      });
    }
  };
  return makeApiCall(requestObj);
};

export const deleteAttachment = files => (dispatch, getState) => {
  const { cmsData } = getState();
  const { emailData } = cmsData;
  dispatch({
    type: cmsActions.ADD_ATTACHMENT,
    payload: { isLoading: true }
  });

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'deleteAttachment',
    method: 'POST',
    data: files,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch({
          type: cmsActions.DELETE_ATTACHMENT,
          payload: {
            newCommunication: true
          }
        });
        let data = [];
        if (emailData.attachmentsDTO && emailData.attachmentsDTO.length > 1) {
          data = emailData.attachmentsDTO.filter(elem => elem.id !== files.id);
        }
        dispatch(updateEmailDataObj('attachmentsDTO', data));
      } else {
        dispatch({
          type: cmsActions.DELETE_ATTACHMENT
        });
        toastr.error('Error', 'Failed to get Emails');
      }
    },
    failureCb: err => {
      dispatch({
        type: cmsActions.DELETE_ATTACHMENT,
        payload: {
          isLoadingData: false
        }
      });
    },
    catchCb: err => {
      dispatch({
        type: cmsActions.DELETE_ATTACHMENT,
        payload: {
          isLoadingData: false
        }
      });
    }
  };
  return makeApiCall(requestObj);
};

export const downloadCSV = id => dispatch => {
  dispatch({
    type: cmsActions.SET_IS_LOADING_DATA,
    payload: true
  });

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'downloadCSV',
    method: 'POST',
    pathVariables: [{ key: '{communicationId}', val: id }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch({
          type: cmsActions.DOWNLOAD_CSV,
          payload: res.payload
        });
        dispatch({
          type: cmsActions.SET_IS_LOADING_DATA,
          payload: false
        });
      } else {
        toastr.error('Error', 'Failed ');
      }
    },
    failureCb: err => {
      dispatch({
        type: cmsActions.SET_IS_LOADING_DATA,
        payload: false
      });
    },
    catchCb: err => {
      dispatch({
        type: cmsActions.SET_IS_LOADING_DATA,
        payload: false
      });
    }
  };
  return makeApiCall(requestObj);
};
